/** Public publisher contact for OpenFinance / GeoKing. */
export const PUBLISHER_EMAIL = 'contact@geoking.fr';
